export enum AvailabilityKind {
	TRANSPORT = 'transport',
	ROOM = 'room',
}
